import React from 'react';

import Appbar, { AppbarBrand } from '@parkholidays/legacy_components/dist/appbar';
import Container from '@parkholidays/legacy_components/dist/container';
import Image from '@parkholidays/legacy_components/dist/image';
import { privacyPolicy } from '../config/urls';

const mobileViewPort = 769;

function withCheckoutLayout(Component) {
  // build
  function CheckoutLayout(props) {
    const [isMobile, setIsMobile] = React.useState('false');

    React.useEffect(() => {
      setIsMobile(window.innerWidth < mobileViewPort);
    }, [setIsMobile]);
    return (
      <>
        <Appbar
          color="corporate"
          $style={{
            paddingTop: '8px',
            borderBottomWidth: '4px',
            borderBottomStyle: 'solid',
            borderBottomColor: '#2e9cc0',
            paddingBottom: '8px',
          }}
        >
          <AppbarBrand
            to="/"
            $style={{
              display: 'flex',
              gap: '1rem',
              '@media (max-width: 767px)': {
                gap: '2rem',
              },
            }}
          >
            <Image
              src="https://assets.parkholidays.com/static_assets/svg_logo/white_redflag.svg"
              alt="Park Holidays UK Logo"
              width="150"
            />
            <Image
              src="https://assets.parkholidays.com/assets/5077532769d88aaf403005dd862ef678.png"
              alt="Park Leisure Logo"
              width="150"
            />
          </AppbarBrand>
          {!isMobile && (
            <a
              href={privacyPolicy}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white', fontSize: '1.25rem', fontWeight: '700' }}
            >
              Privacy Policy
            </a>
          )}
        </Appbar>
        <main style={{paddingBottom: isMobile ? '2rem' : 0}}>
          <Component {...props} />
          {isMobile ? (
            <Container $style={{ marginTop: '2rem',}}>
              <a
                href={privacyPolicy}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  borderBottom: '2px solid #1a4a8a',
                  color: '#0C5595',
                  fontSize: '1rem',
                  fontWeight: '700',
                  textDecoration: 'none',
                }}
              >
                Privacy Policy
              </a>
            </Container>
          ): null}
        </main>
      </>
    );
  }

  return CheckoutLayout;
}

export default withCheckoutLayout;
